import { DOMAIN } from "shared/SharedConstants";
import type { AppEnvironment } from "shared/UtilTypes";

// These initializers only read configuration; allow builds to drop unused exports.

export const APP_ENVIRONMENT = import.meta.env.PUBLIC_ENVIRONMENT as AppEnvironment | undefined;
export const APP_ORIGIN = import.meta.env.PUBLIC_ORIGIN || "http://localhost:6100";
export const APP_VERSION = import.meta.env.PUBLIC_APP_VERSION;

export const CONTACT_EMAIL = /* @__PURE__ */ (() => `contact@${DOMAIN}`)();

const BASE_URLS: any = /* @__PURE__ */ (() => ({
  main: `https://api.${DOMAIN}/internal/v1`,
  dev: `https://api.dev.${DOMAIN}/internal/v1`,
  local: `http://${typeof window === "undefined" ? "localhost" : window.location.hostname}:6110/internal/v1`,
}))();
export const BACKEND_URL = /* @__PURE__ */ (() =>
  import.meta.env.PUBLIC_BACKEND_URL || BASE_URLS[APP_ENVIRONMENT || "local"])();

const PUBLIC_URLS: any = /* @__PURE__ */ (() => ({
  main: `https://api.${DOMAIN}/v1`,
  dev: `https://api.dev.${DOMAIN}/v1`,
  local: BACKEND_URL.replace(/\/internal\/v1$/u, "/v1"),
}))();
export const PUBLIC_URL = /* @__PURE__ */ (() =>
  import.meta.env.PUBLIC_API_URL || PUBLIC_URLS[APP_ENVIRONMENT || "local"])();

export const BREAKPOINTS = {
  desktop: { min: 920, max: 9999 },
  mobile: { min: 0, max: 920 },
} as const;

export const REDIRECT_BY_DEFAULT = true;
export const FORCE_REDIRECT_IN_DEV = false;
export const ENABLE_REDIRECT = FORCE_REDIRECT_IN_DEV || process.env.NODE_ENV === "production";

/** Whether the landing hero shows CalmLens transforming each approved file before it is served. */
export const ENABLE_HERO_TRANSFORM = false;
